<div class="d-flex flex-column h-100 gap-8">
  @if (trackFromMapLoading()) {
    <div class="d-flex flex-column gap-8 justify-content-center align-items-center h-100">
      <si-loading-spinner />
      <div class="d-flex flex-column gap-2">
        <p class="text-center m-0">{{ 'TRACK.IMPORTING_TRACK_FROM_MAP' | translate }}</p>
        <button type="button" class="btn btn-tertiary" (click)="stopImportTrackFromMap()">
          {{ 'SHARED.CANCEL' | translate }}
        </button>
      </div>
    </div>
  } @else {
    <!-- Top Button -->
    <div class="d-flex gap-5 align-items-center" data-tour-id="tour-track-load-import">
      <button type="button" class="btn btn-secondary" (click)="openModal(selectTrackModalTemplate)">
        <i class="icon element-database"></i>{{ 'SHARED.LOAD' | translate }}
      </button>
      <button type="button" class="btn btn-secondary" [cdkMenuTriggerFor]="importContextMenu">
        <i class="icon element-import"></i>{{ 'SHARED.IMPORT' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        data-tour-id="tour-map-button"
        (click)="toggleMap()"
      >
        <i class="icon element-map-location"></i>{{ 'MAP.MAP' | translate }}
      </button>
    </div>

    <!-- Data Div -->
    @if (selectedTrack(); as track) {
      <div class="d-flex flex-column h-100 overflow-hidden gap-5">
        <!-- Title -->
        <div class="d-flex justify-content-between align-items-start">
          <div class="mh-46p d-flex flex-column gap-2 align-items-start">
            <div class="d-flex flex-column gap-1 align-items-start">
              <div class="d-flex align-items-center flex-wrap">
                <h3 class="d-inline fw-bold my-0">
                  {{ !track.id ? (track.name | starPrefix) : track.name }}
                </h3>
                @if (track.version) {
                  <h2 class="d-inline my-0 ms-2">
                    <em>{{ track.version | bracket }}</em>
                  </h2>
                }
                @if (canEdit()) {
                  <button
                    type="button"
                    class="btn btn-circle btn-md btn-ghost element-edit ms-3"
                    aria-label="edit"
                    [disabled]="renameInProgress()"
                    (click)="openRenameModal(renameTrackModalTemplate)"
                  ></button>
                }
              </div>
              @if (track.description) {
                <small class="text-secondary">{{ track.description }}</small>
              }
            </div>
            @if (track.source) {
              <p class="si-body-1 my-0">
                {{ 'TRACK.SOURCE' | translate }}:
                <span class="text-primary">{{ track.source }}</span>
              </p>
            }
          </div>

          <button
            type="button"
            class="btn btn-circle btn-lg btn-ghost element-state-close"
            aria-label="close"
            (click)="closeTrackClicked()"
          ></button>
        </div>
        <app-track-table
          class="h-100 w-100 overflow-auto"
          [(selectedTrack)]="selectedTrack"
          (buttonsDisabledChanged)="this.buttonsDisabled.set($event)"
          (editRouteRequested)="openMapWithRoute($event)"
        />
      </div>

      <!-- Bottom Button -->
      <div class="d-flex gap-5 align-items-center align-self-end">
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="buttonsDisabled()"
          [cdkMenuTriggerFor]="exportContextMenu"
        >
          <i class="icon element-export"></i>{{ 'SHARED.EXPORT' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-secondary mt-auto"
          [disabled]="buttonsDisabled()"
          (click)="openSaveTrackModal(saveTrackModalTemplate)"
        >
          <i class="icon element-database"></i>{{ 'SHARED.SAVE' | translate }}
        </button>
      </div>
    } @else {
      <div class="d-flex justify-content-center align-items-center h-100">
        <p class="text-center">
          <span>{{ 'SHARED.INFO_LOAD' | translate: { type: ('TRACK.TRACK' | translate) } }}</span
          ><br />
          <span>{{ 'SHARED.OR' | translate }}</span>
          <br />
          <button type="button" class="btn btn-tertiary" (click)="createNewTrack()">{{
            'SHARED.CREATE_NEW' | translate
          }}</button>
        </p>
      </div>
    }
  }
</div>

<ng-template #actionHeaderCellTemplate>
  <span class="visually-hidden"></span>
</ng-template>

<!-- Modal Templates -->
<ng-template #selectTrackModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'LOAD_MODAL.HEADING' | translate: { type: ('TRACK.TRACKS' | translate) } }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <app-load-modal
      class="h-100"
      dataType="track"
      (openItemClicked)="this.closeModal(modalRef); openTrackClicked($event)"
    />
  </div>
</ng-template>

<ng-template #saveTrackModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'SAVE_MODAL.HEADING' | translate: { type: ('TRACK.TRACK' | translate) } }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    @if (selectedTrack(); as track) {
      <app-save-modal
        class="h-100"
        mode="save"
        dataType="track"
        [itemToSave]="track"
        [availableWorkspaces]="availableWorkspaces()"
        (saveItemClicked)="this.closeModal(modalRef); handleSaveNewTrack($event)"
      />
    }
  </div>
</ng-template>

<ng-template #renameTrackModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'TRACK.RENAME.CONFIRM_HEADING' | translate }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    @if (selectedTrack(); as track) {
      <app-save-modal
        class="h-100"
        mode="rename"
        dataType="track"
        [itemToSave]="track"
        (renameItemClicked)="this.closeModal(modalRef); handleRenameTrack($event)"
      />
    }
  </div>
</ng-template>

<ng-template #importContextMenu>
  <si-menu>
    <si-menu-item (click)="openFileSelector('json')">JSON</si-menu-item>
    <si-menu-item (click)="openFileSelector('drive')">DRIVE</si-menu-item>
  </si-menu>
</ng-template>

<!-- Hidden file inputs  -->
<input
  #jsonFileInput
  type="file"
  accept=".json"
  class="d-none"
  (change)="onJSONFileSelected($event)"
/>

<input
  #driveFileInput
  type="file"
  accept=".drive"
  class="d-none"
  (change)="onDriveFileSelected($event)"
/>

<ng-template #exportContextMenu>
  <si-menu>
    <si-menu-item (click)="exportTrackDataAsJSON()">JSON</si-menu-item>
    <si-menu-item (click)="exportTrackDataAsXNDS()">XNDS</si-menu-item>
  </si-menu>
</ng-template>

<app-map [initialWaypoints]="mapInitialWaypoints()" [(isOpened)]="isMapOpened" />
